// src/modules/public/pages/HelpPage/index.js
import React from 'react';
import { Container } from 'react-bootstrap';
import HelpView from '../../components/HelpView';

const HelpPage = () => {
    return (
        <Container>
            <HelpView />
        </Container>
    );
};

export default HelpPage;
